import { Grid3x3, ArrowRight, Lock } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';

interface ManageCardProps {
  onNavigate?: (page: string) => void;
}

export function ManageCard({ onNavigate }: ManageCardProps) {
  const { user } = useAuth();
  const hasOrdersAccess = user?.permissions?.includes('orders') ?? false;

  return (
    <button 
      onClick={() => onNavigate?.('orders')}
      disabled={!hasOrdersAccess}
      className={`bg-gradient-to-br from-gray-700 via-gray-800 to-gray-900 rounded-2xl p-8 text-white shadow-lg transition-all duration-200 flex flex-col items-center justify-center relative w-full text-left ${
        hasOrdersAccess 
          ? 'hover:shadow-xl hover:-translate-y-1 cursor-pointer' 
          : 'opacity-50 cursor-not-allowed'
      }`}
      style={{ height: '320px' }}
    >
      {!hasOrdersAccess && (
        <div className="absolute top-4 right-4">
          <Lock className="w-5 h-5 text-white/60" />
        </div>
      )}
      
      <div className="flex items-center justify-center mb-6">
        <div className="w-16 h-16 border-2 border-white/40 rounded-xl flex items-center justify-center bg-white/5">
          <Grid3x3 className="w-8 h-8" />
        </div>
      </div>
      
      <div className="text-center">
        <h3 className="text-lg font-bold leading-relaxed">
          Manage<br />Orders
        </h3>
        <div className="flex items-center justify-center gap-2 mt-3">
          <p className="text-xs text-white/60">
            {hasOrdersAccess ? 'View and manage all orders' : 'Requires orders permission'}
          </p>
          {hasOrdersAccess && <ArrowRight className="w-4 h-4 text-white/70" />}
        </div>
      </div>
    </button>
  );
}